export const analyticsViewTypesList = [
  {
    key: "Test Orders Only",
    description:
      "Recommended if test products are not substitutes with other products in your store and do not make up a large portion (>40%) of your store's revenue.",
    value: "test_orders_only",
  },
  {
    key: "Sitewide Orders",
    description:
      "Recommended if test products are substitutes for other products in your store or constitute a large portion (>40%) of your store's revenue.",
    value: "sitewide_orders",
  },
  {
    key: "Ask me later",
    description: "",
    value: "none",
  },
];
